import { WPSettings } from '@/WPSettings'

let lang = WPSettings.LANGUAGE
if (lang === 'nl') {
  lang = ''
} else {
  lang = `_${lang}`
}

interface Option {
  name: string
  price?: string
}

export default class Settings {
  public general: {}
  public modules: {}

  constructor(data: any) {
    this.general = new GeneralSettings(data.general)
    this.modules = new ModuleSettings(data.modules)
  }
}

class GeneralSettings {
  public termsUrl: ''
  public mainColor: ''
  public mainTextColor: ''
  public defaultView: ''
  public defaultSorting: ''
  public showDeliverOptions: false
  public contactInfo: {}
  public companyInfo: {}[]
  public additionalWarranty: {}
  public showCompare: true
  public mergeModels: false
  public warranties: []
  public deliveries: []

  constructor(data: any) {
    this.termsUrl = data.terms_url
    this.mainColor = data.main_color ? data.main_color : null
    this.mainTextColor = data.main_text_color ? data.main_text_color : 'black'
    this.defaultView = data.default_view ? data.default_view : 'list'
    this.defaultSorting = data.default_sorting ? data.default_sorting : 'relevance'
    this.showDeliverOptions = data.show_deliver_options ? data.show_deliver_options : false
    if (data.show_additional_warranty) {
      this.additionalWarranty = {
        active: data.show_additional_warranty,
        url: data.additional_warranty_page,
      }
    } else {
      this.additionalWarranty = {
        active: false,
        url: null,
      }
    }
    this.showCompare = data.show_compare ? data.show_compare : false
    this.mergeModels = data.merge_models ? data.merge_models : false
    this.contactInfo = {
      email: data.contact_info.email ? data.contact_info.email : null,
      image: data.contact_info.image ? data.contact_info.image : null,
      jobTitle: data.contact_info.job_title ? data.contact_info.job_title : null,
      name: data.contact_info.name ? data.contact_info.name : null,
      phone: data.contact_info.phone ? data.contact_info.phone : null,
    }

    this.companyInfo = []
    for (const row of data.company_info) {
      this.companyInfo.push({
        customerId: row.customer_id ?? null,
        name: row.company_name ?? null,
        street: row.street ?? null,
        zip: row.zip ?? null,
        city: row.city ?? null,
        phone: row.phone ?? null,
        email: row.email ?? null,
        whatsapp: row.whatsapp ?? null,
      })
    }

    this.warranties = data.warranties ? data.warranties : []
    this.deliveries = data.deliveries ? data.deliveries : []
  }
}

class ModuleSettings {
  public callMeBack: {}
  public financeCalculator: {}
  public offer: {}
  public taxtool: {}
  public testRide: {}
  public privateLease: {}
  public buy: {}
  public appointment: {}

  constructor(data: any) {
    this.callMeBack = new ModuleCallMeBack(data.call_me_back)
    this.financeCalculator = new ModuleFinanceCalculator(data.finance_calculator)
    this.offer = new ModuleOffer(data.offer)
    this.taxtool = new ModuleTaxtool(data.taxtool)
    this.testRide = new ModuleTestRide(data.test_ride)
    this.privateLease = new ModulePrivateLease(data.private_lease)
    this.buy = new ModuleBuy(data.buy)
    this.appointment = new ModuleAppoinment(data.appointment)
  }
}

class ModuleCallMeBack {
  public active: boolean
  public highlighted: boolean
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}

class ModuleFinanceCalculator {
  public active: boolean
  public highlighted: boolean
  public toolType: string
  public minFinanceValue: number
  public interestRate: number
  public leasetoolDealerId: number
  public deautofinancierDealerId: string
  public rosfinanceAPIKey: string
  public bekaroUniqueKey: string
  public financialLeaseDealerId: string
  public bdlease : {}
  public introText: string
  public defaultDeposit: number
  public useDeliveries: boolean

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.toolType = data.settings && data.settings.tool_type ? data.settings.tool_type : 'standard'
    this.minFinanceValue =
      data.settings && data.settings.min_finance_value ? parseFloat(data.settings.min_finance_value) : 0
    this.interestRate = data.settings && data.settings.interest_rate ? parseFloat(data.settings.interest_rate) : 0
    this.defaultDeposit =
      data.settings && data.settings.finance_default_deposit ? parseFloat(data.settings.finance_default_deposit) : 0
    this.leasetoolDealerId =
      data.settings && data.settings.leasetool_dealer_id ? data.settings.leasetool_dealer_id : false
    this.deautofinancierDealerId =
      data.settings && data.settings.deautofinancier_dealer_id ? data.settings.deautofinancier_dealer_id : false
    this.rosfinanceAPIKey = data.settings && data.settings.rosfinance_api_key ? data.settings.rosfinance_api_key : false
    this.bekaroUniqueKey =
      data.settings && data.settings.bekaro_unique_key ? data.settings.bekaro_unique_key : false
    this.financialLeaseDealerId =
      data.settings && data.settings.financiallease_dealer_id ? data.settings.financiallease_dealer_id : false
    this.bdlease = new FinanceCalcularoBdlease(data?.settings)
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
    this.useDeliveries = data && data.settings?.finance_use_deliveries ? data.settings.finance_use_deliveries : false
  }
}

class FinanceCalcularoBdlease {
    public dealerId : string
    public defaultClosingTerm : number
    public defaultDeposit : number
    public defaultTab : string

    constructor(data: any) {
        this.dealerId = data && data.bdlease_dealer_id ? data.bdlease_dealer_id : null
        this.defaultClosingTerm = data && data.bdlease_default_closing_term ? parseInt(data.bdlease_default_closing_term) : 0
        this.defaultDeposit = data && data.bdlease_default_deposit ? parseInt(data.bdlease_default_deposit) : 0
        this.defaultTab = data && data.bdlease_default_tab ? data.bdlease_default_tab : 'private'
    }
}

class ModuleOffer {
  public active: boolean
  public highlighted: boolean
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}

class ModuleTaxtool {
  public active: boolean
  public highlighted: boolean
  public clientId: string
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.clientId = data.settings && data.settings.client_id ? data.settings.client_id : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}

class ModuleTestRide {
  public active: boolean
  public highlighted: boolean
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}
class ModulePrivateLease {
  public active: boolean
  public highlighted: boolean
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}
class ModuleBuy {
  public active: boolean
  public highlighted: boolean
  public packages: object[]
  public options: Option[]
  public introText: string
  public useDeliveries: boolean
  // public homeDeliveryPrice: string
  // public roadsideAssistancePrice: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.packages = data && data.settings?.delivery_packages ? data.settings.delivery_packages : []
    this.options = this.buildOptions(data)
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
    this.useDeliveries = data && data.settings?.buy_use_deliveries ? data.settings.buy_use_deliveries : false
  }
  buildOptions(data: any): Option[] {
    const options: Option[] = []
    if (data && data.settings?.buy_options_options) {
      data.settings.buy_options_options.forEach((option: string) => {
        options.push({ name: option })
      })
      if (data.settings?.buy_option_home_delivery) {
        const hd = options.find((o) => o.name === 'home_delivery')
        if (hd) {
          hd.price = data.settings.buy_option_home_delivery.buy_options_home_delivery_price
            ? data.settings.buy_option_home_delivery.buy_options_home_delivery_price
            : null
        }
      }
      if (data.settings?.buy_option_road_assistance) {
        const ra = options.find((o) => o.name === 'roadside_assistance')
        if (ra) {
          ra.price = data.settings.buy_option_road_assistance.buy_options_road_assistance_price
            ? data.settings.buy_option_road_assistance.buy_options_road_assistance_price
            : null
        }
      }
      if (data.settings?.buy_option_insurance) {
        const ins = options.find((o) => o.name === 'insurance')
        if (ins) {
          ins.price = data.settings.buy_option_insurance.buy_options_insurance_price
            ? data.settings.buy_option_insurance.buy_options_insurance_price
            : null
        }
      }
    }
    return options
  }
}

class ModuleAppoinment {
  public active: boolean
  public highlighted: boolean
  public introText: string

  constructor(data: any) {
    this.active = data && data.active ? data.active : false
    this.highlighted = data && data.highlighted ? data.highlighted : false
    this.introText =
      data && data.active && data?.settings[`intro_text${lang}`] ? data.settings[`intro_text${lang}`] : null
  }
}
